var React = require('react');

function LeftArrowAlt (props) {
    return React.createElement("svg",props,React.createElement("path",{"d":"M-5.24537e-07 11L10.8 0.607696L10.8 21.3923L-5.24537e-07 11Z","fill":"#676A72"}));
}

LeftArrowAlt.defaultProps = {"width":"11","height":"22","viewBox":"0 0 11 22","fill":"none"};

module.exports = LeftArrowAlt;

LeftArrowAlt.default = LeftArrowAlt;
